// @ts-expect-error upstream is not migrated to TypeScript
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import withErrorBoundary from '../ErrorBoundary';
import { UI_REQUEST_PRODUCT_BUTTON } from '../_core/common/constants/ErrorBoundaryNames';
import { upgradeDataPropsInterface } from '../_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { track } from '../_core/common/eventTracking/tracker';
import { requestSKU } from '../_core/upgrade/requestSKU';
import { _getHubAndTierProperties, getSource, getUpgradeDataTrackingProperties } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RequestProductPropsInterface = Object.assign({}, upgradeDataPropsInterface, {
  use: PropTypes.string,
  className: PropTypes.string
});
const getTrackingProperties = upgradeData => {
  const {
    apiName,
    upgradeProduct,
    app,
    screen,
    uniqueId,
    upgradeKey,
    pointType,
    feature,
    upgradeSource
  } = upgradeData;
  const apiNameMaybe = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const {
    hub,
    tier
  } = _getHubAndTierProperties({
    upgradeProduct,
    apiName: apiNameMaybe
  });
  const source = upgradeData.source || getSource(upgradeData.app, upgradeData.screen, upgradeData.uniqueId);
  return {
    app,
    screen,
    uniqueId,
    upgradeProduct,
    apiName: apiNameMaybe,
    source,
    upgradeKey,
    pointType,
    feature,
    upgradeSource,
    hub,
    tier
  };
};
const UIRequestProductButton = ({
  upgradeData,
  isUpgradePoint,
  buttonSize,
  onClick = () => {},
  use = 'primary',
  block,
  disabled,
  'data-selenium-id': dataSeleniumId,
  'data-test-id': dataTestId
}) => {
  const [showModal, setShowModal] = useState(false);
  const [localAlertStore] = useState(() => {
    return FloatingAlertStore.newFloatingAlertStore();
  });
  useEffect(() => {
    track('requestProductButton', Object.assign({
      action: 'viewed'
    }, getTrackingProperties(upgradeData)));
  }, [upgradeData]);
  const handleSendRequest = () => {
    requestSKU({
      apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct]
    }).then(() => {
      setShowModal(false);
      localAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onSuccessAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onSuccessAlert.title"
        }),
        type: 'success'
      });
    }).catch(__error => {
      localAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onFailureAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onFailureAlert.title"
        }),
        type: 'danger'
      });
    });
  };
  const handleButtonClick = () => {
    setShowModal(true);
    onClick();
    track('requestProductButton', Object.assign({
      action: 'clicked'
    }, getTrackingProperties(upgradeData)));
    if (isUpgradePoint) {
      track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      alertStore: localAlertStore
    }), /*#__PURE__*/_jsx(Button, {
      block: block,
      "data-selenium-id": dataSeleniumId,
      "data-test-id": dataTestId || 'request-product-button',
      disabled: disabled,
      onClick: handleButtonClick,
      size: buttonSize,
      use: use,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.requestProduct.button.defaultButtonCopy"
      })
    }), showModal && /*#__PURE__*/_jsxs(Modal, {
      use: "success",
      inlineSize: "540px",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: () => {
            setShowModal(false);
          }
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestProduct.modal.title"
          })
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(Text, {
          paddingInlineEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestProduct.modal.description"
          })
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "request-product-modal-submit-button",
          use: "primary",
          onClick: handleSendRequest,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestProduct.modal.primaryCta"
          })
        })
      })]
    })]
  });
};
export default withErrorBoundary(UIRequestProductButton, {
  boundaryName: UI_REQUEST_PRODUCT_BUTTON
});